<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'StepResolve',
})
</script>
<template>
  <TlDetailItem :title="title" color="green">
    <TlDetailField label="审核人">{{ record?.createAdminUserObj?.loginName }}</TlDetailField>
    <TlDetailField label="审核时间">{{ record?.createdAt }}</TlDetailField>
    <TlDetailField label="审核意见">{{ record?.shenHeYiJian }}</TlDetailField>
    <TlDetailField label="附件" v-if="fileVisible">
      <FileDisplayNormals :files="fuJian" :colAttrs="{ span: 12 }" />
    </TlDetailField>
  </TlDetailItem>
</template>

<script lang="ts" setup name="StepResolve">
import { computed } from 'vue'
import { FileDisplayNormals } from '-/Common/FileDisplay'
import TlDetailField from './TlDetailField.vue'
import TlDetailItem from './TlDetailItem.vue'
const props = withDefaults(
  defineProps<{
    record?: any
    fileVisible?: boolean
    title?: string
  }>(),
  {
    fileVisible: true,
    title: '同意'
  }
)
// 附件
const fuJian = computed(() => props.record?.files?.fuJian ?? [])
</script>
